import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import ProjectRoutes from "ProjectRoutes";

function App() {
  return (
    <Router>
      <ProjectRoutes />
    </Router>
  );
}

export default App;
